import { Link } from 'react-router'
import { useTranslation } from 'react-i18next'
import { Language, AVAILABLE_LANGUAGES } from '@/domains/Language'

type LangPreferenceProps = {
  language?: Language
}

const LangPreference = ({ language }: LangPreferenceProps) => {
  const { t, i18n } = useTranslation('common')

  const currentLanguage =
    language ?? AVAILABLE_LANGUAGES.find((lang) => lang.code === i18n.language)

  return (
    <Link
      to="/select-lang"
      viewTransition
      className="flex justify-between items-center py-3 hover:bg-gray-50 rounded-md px-2 -mx-2"
    >
      <div>
        <p className="font-medium">{t('components.preferences.language')}</p>
        <p className="text-sm text-gray-500">
          {currentLanguage
            ? `${currentLanguage.flag} ${t(currentLanguage.nameKey)}`
            : t('components.preferences.not-defined')}
        </p>
      </div>
      <img src="/icons/chevron.svg" width={24} height={24} alt="right chevron" />
    </Link>
  )
}

export default LangPreference
